/* eslint-disable react/no-unknown-property */
/* eslint-disable react/no-unescaped-entities */
import React, { Component } from "react";
import {
  Lock,
  Mail,
  Eye,
  EyeOff,
  Shield,
  UserPlus,
  CheckCircle,
  AlertCircle,
  Calendar,
  Briefcase,
  Crown,
  Users,
  QrCode,
  Phone,
  X,
  Gift,
  ShoppingCart,
  Tag,
} from "lucide-react";
import { Navigate } from "react-router-dom";
import PhoneInput from "react-phone-number-input";
import "react-phone-number-input/style.css";
import { CountryDropdown, RegionDropdown } from "react-country-region-selector";

import trLabels from "react-phone-number-input/locale/tr.json";



export default class Register extends Component {
  constructor(props) {
    super(props);
    this.state = {
      selectedOption: "register",
      giftCodeQuantity: 1,
      showPassword: false,
      showConfirmPassword: false,
      isLoading: false,
      registerData: {
        firstName: "",
        lastName: "",
        country: "Turkey",
        city: "",
        gender: "",
        birthDate: "",
        email: "",
        password: "",
        confirmPassword: "",
        careerLevel: "",
        // goldenLionLeader: "",
        referenceCode: "",
        giftCode: "",
        phone: "",
        acceptTerms: false,
        acceptPrivacy: false,
        acceptMarketing: false,
      },
      message: { type: "", text: "" },
      shouldRedirect: null,
      paymentPageHTML: null,
      showPaymentPage: false,
      giftCodePhone: "",
      redirectTimer: null,
      giftCodeAcceptTerms: false,
    };
  }

  API_BASE_URL = process.env.REACT_APP_API_URL;

  buildHeaders = () => ({
    "Content-Type": "application/json",
  });

  componentWillUnmount() {
    if (this.state.redirectTimer) {
      clearTimeout(this.state.redirectTimer);
    }
  }

  isHTMLResponse = (text) => {
    return (
      text.trim().startsWith("<!DOCTYPE") ||
      text.trim().startsWith("<html") ||
      text.includes("<form") ||
      text.includes("VirtualPOS.Gateway")
    );
  };

  handleApiError = (
    error,
    defaultMessage = "Bir hata oluştu. Lütfen tekrar deneyin."
  ) => {
    console.error("API Error:", error);

    let errorMessage = defaultMessage;

    if (error.message === "Failed to fetch") {
      errorMessage = "Bağlantı hatası. İnternet bağlantınızı kontrol edin.";
    } else if (error.name === "TypeError") {
      errorMessage =
        "Sunucuya bağlanılamadı. Lütfen daha sonra tekrar deneyin.";
    } else if (error.message.includes("HTTP")) {
      if (
        error.message == "HTTP : Bu email ya da telefon numarası zaten kayıtlı."
      ) {
        errorMessage = "Bu email ya da telefon numarası zaten kayıtlı.";
      } else if (
        error.message == "HTTP : Bağlantı hatası. Lütfen tekrar deneyin."
      ) {
        errorMessage = "Bağlantı hatası. Lütfen tekrar deneyin.";
      } else if (error.message == "HTTP : Veri hatası oluştu.") {
        errorMessage = "Veri hatası oluştu.";
      } else if (
        error.message == "HTTP : Lütfen tüm zorunlu alanları doldurun."
      ) {
        errorMessage = "Lütfen tüm zorunlu alanları doldurun.";
      } else {
        errorMessage = "Sunucu hatası. Lütfen daha sonra tekrar deneyin.";
      }
    }

    this.setState({
      message: { type: "error", text: errorMessage },
      isLoading: false,
    });
  };

  completeGiftCodeRegistration = async () => {
    try {
      const { registerData } = this.state;

      const giftCodeError = this.validateGiftCode(registerData.giftCode);
      if (giftCodeError) {
        this.setState({
          message: { type: "error", text: giftCodeError },
          isLoading: false,
        });
        return;
      }

      const response = await fetch(
        `${this.API_BASE_URL}/api/odeme/with-gift-code`,
        {
          method: "POST",
          headers: this.buildHeaders(),
          body: JSON.stringify(registerData),
        }
      );

      if (!response.ok) {
        const errorText = await response.text();
        let errorMessage = "Kayıt işlemi başarısız.";

        try {
          const errorJson = JSON.parse(errorText);
          errorMessage = errorJson.message || errorMessage;
        } catch (e) {}

        throw new Error(`HTTP : ${errorMessage}`);
      }

      const contentType = response.headers.get("content-type");

      if (!contentType || !contentType.includes("application/json")) {
        throw new Error("Geçersiz yanıt formatı. Beklenen JSON formatı.");
      }

      const result = await response.json();

      if (result.success) {
        this.setState({
          message: {
            type: "success",
            text:
              result.message ||
              "Hediye kodu ile kayıt başarıyla tamamlandı! 3 saniye içinde giriş sayfasına yönlendirileceksiniz.",
          },
          isLoading: false,
        });

        const timer = setTimeout(() => {
          this.setState({ shouldRedirect: "/login" });
        }, 3000);

        this.setState({ redirectTimer: timer });
      } else {
        this.setState({
          message: {
            type: "error",
            text:
              result.message || "Hediye kodu ile kayıt işleminde hata oluştu.",
          },
          isLoading: false,
        });
      }
    } catch (error) {
      this.handleApiError(
        error,
        "Hediye kodu kayıt işleminde hata oluştu. Lütfen tekrar deneyin."
      );
    }
  };

  completeRegistration = async () => {
    try {
      const { registerData } = this.state;

      const response = await fetch(`${this.API_BASE_URL}/api/odeme/odemeYap`, {
        method: "POST",
        headers: this.buildHeaders(),
        body: JSON.stringify(registerData),
      });

      if (!response.ok) {
        const errorText = await response.text();
        let errorMessage = "Kayıt işlemi başarısız.";

        try {
          const errorJson = JSON.parse(errorText);
          errorMessage = errorJson.message || errorMessage;
        } catch (e) {}

        throw new Error(`HTTP : ${errorMessage}`);
      }

      const text = await response.text();

      if (this.isHTMLResponse(text)) {
        document.open();
        document.write(text);
        document.close();

        this.setState({
          paymentPageHTML: text,
          showPaymentPage: true,
          message: { type: "", text: "" },
          isLoading: false,
        });
      } else {
        try {
          const result = JSON.parse(text);
          if (!result.success) {
            this.setState({
              message: {
                type: "error",
                text: result.message || "Kayıt işlemi başarısız.",
              },
              isLoading: false,
            });
          }
        } catch (parseError) {
          throw new Error("Geçersiz yanıt formatı");
        }
      }
    } catch (error) {
      this.handleApiError(
        error,
        "Kayıt işlemi sırasında hata oluştu. Lütfen tekrar deneyin."
      );
    }
  };

  handleGiftCodePurchase = async () => {
    try {
      const { giftCodeQuantity, giftCodePhone, giftCodeAcceptTerms } =
        this.state;

      if (!giftCodeAcceptTerms) {
        this.setState({
          message: {
            type: "error",
            text: "Hediye kodu satın almak için üyelik & satış sözleşmesini kabul etmelisiniz.",
          },
          isLoading: false,
        });
        return;
      }

      if (giftCodeQuantity < 1 || giftCodeQuantity > 100) {
        this.setState({
          message: {
            type: "error",
            text: "Hediye kodu adedi 1-100 arasında olmalıdır.",
          },
          isLoading: false,
        });
        return;
      }

      const response = await fetch(
        `${this.API_BASE_URL}/api/odeme/odemeYapHediyeKodu`,
        {
          method: "POST",
          headers: this.buildHeaders(),
          body: JSON.stringify({
            orderCount: giftCodeQuantity,
            phone: giftCodePhone || null,
          }),
        }
      );

      if (!response.ok) {
        const errorText = await response.text();
        let errorMessage = "Hediye kodu satın alma işlemi başarısız.";
        try {
          const errorJson = JSON.parse(errorText);
          errorMessage = errorJson.message || errorMessage;
        } catch (e) {}
        throw new Error(`HTTP : ${errorMessage}`);
      }

      const text = await response.text();

      if (this.isHTMLResponse(text)) {
        document.open();
        document.write(text);
        document.close();
        this.setState({
          paymentPageHTML: text,
          showPaymentPage: true,
          message: { type: "", text: "" },
          isLoading: false,
        });
      } else {
        try {
          const result = JSON.parse(text);
          this.setState({
            message: {
              type: "error",
              text:
                result.message || "Hediye kodu satın alma işlemi başarısız.",
            },
            isLoading: false,
          });
        } catch (parseError) {
          throw new Error("Geçersiz yanıt formatı");
        }
      }
    } catch (error) {
      this.handleApiError(
        error,
        "Hediye kodu satın alma işleminde hata oluştu. Lütfen tekrar deneyin."
      );
    }
  };

  handleRegister = async (e) => {
    e.preventDefault();

    this.setState({ isLoading: true, message: { type: "", text: "" } });

    if (this.state.selectedOption === "giftCode") {
      await this.handleGiftCodePurchase();
      return;
    }

    const { registerData } = this.state;

    if (registerData.password !== registerData.confirmPassword) {
      this.setState({
        message: { type: "error", text: "Şifreler eşleşmiyor!" },
        isLoading: false,
      });
      return;
    }

    if (!registerData.acceptTerms || !registerData.acceptPrivacy) {
      this.setState({
        message: {
          type: "error",
          text: "Lütfen kullanım şartlarını ve gizlilik politikasını kabul edin.",
        },
        isLoading: false,
      });
      return;
    }

    const requiredFields = [
      "firstName",
      "lastName",
      "country",
      "city",
      "gender",
      "birthDate",
      "email",
      "password",
      "careerLevel",
      // "goldenLionLeader",
      "phone",
    ];

    const missingFields = requiredFields.filter(
      (field) => !registerData[field]
    );

    if (missingFields.length > 0) {
      this.setState({
        message: {
          type: "error",
          text: "Lütfen tüm zorunlu alanları doldurun.",
        },
        isLoading: false,
      });
      return;
    }

    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailRegex.test(registerData.email)) {
      this.setState({
        message: { type: "error", text: "Geçerli bir email adresi girin." },
        isLoading: false,
      });
      return;
    }

    if (registerData.password.length < 6) {
      this.setState({
        message: { type: "error", text: "Şifre en az 6 karakter olmalıdır." },
        isLoading: false,
      });
      return;
    }

    // 18 yaş kontrolü — reşit olmayanların kaydı engellenir
    const age = this.calculateAge(registerData.birthDate);
    if (age === null) {
      this.setState({
        message: { type: "error", text: "Geçerli bir doğum tarihi girin." },
        isLoading: false,
      });
      return;
    }
    if (age < 18) {
      this.setState({
        message: {
          type: "error",
          text: "Kayıt olabilmek için en az 18 yaşında olmanız gerekmektedir.",
        },
        isLoading: false,
      });
      return;
    }

    if (registerData.giftCode && registerData.giftCode.trim() !== "") {
      await this.completeGiftCodeRegistration();
    } else {
      await this.completeRegistration();
    }
  };

  // Doğum tarihinden (YYYY-MM-DD) tam yaşı hesaplar; geçersizse null döner.
  calculateAge = (birthDate) => {
    if (!birthDate) return null;
    const dob = new Date(birthDate);
    if (isNaN(dob.getTime())) return null;
    const today = new Date();
    if (dob > today) return null;
    let age = today.getFullYear() - dob.getFullYear();
    const m = today.getMonth() - dob.getMonth();
    if (m < 0 || (m === 0 && today.getDate() < dob.getDate())) {
      age--;
    }
    return age;
  };

  // Doğum tarihi seçicisinin izin verdiği en geç tarih: bugünden 18 yıl önce.
  getMaxBirthDate = () => {
    const d = new Date();
    d.setFullYear(d.getFullYear() - 18);
    return d.toISOString().split("T")[0];
  };

  validateGiftCode = (giftCode) => {
    if (!giftCode || giftCode.trim() === "") {
      return "Hediye kodu boş olamaz.";
    }

    if (giftCode.trim().length < 6) {
      return "Hediye kodu en az 6 karakter olmalıdır.";
    }

    if (giftCode.trim().length > 20) {
      return "Hediye kodu en fazla 20 karakter olabilir.";
    }

    const validPattern = /^[A-Za-z0-9_-]+$/;
    if (!validPattern.test(giftCode.trim())) {
      return "Hediye kodu sadece harf, rakam, tire (-) ve alt çizgi (_) içerebilir.";
    }

    return null;
  };

  handleOptionChange = (option) => {
    if (this.state.redirectTimer) {
      clearTimeout(this.state.redirectTimer);
      this.setState({ redirectTimer: null });
    }

    this.setState({
      selectedOption: option,
      message: { type: "", text: "" },
      isLoading: false,
      giftCodeAcceptTerms: false,
    });
  };

  handleQuantityChange = (quantity) => {
    this.setState({ giftCodeQuantity: Math.max(1, Math.min(100, quantity)) });
  };

  handleInputChange = (field, value) => {
    this.setState({
      registerData: {
        ...this.state.registerData,
        [field]: value,
      },
    });

    if (field === "country") {
      this.setState({
        registerData: {
          ...this.state.registerData,
          [field]: value,
          city: "",
        },
      });
    }

    // Doğum tarihi girildiği anda 18 yaş kontrolü — anında uyarı göster
    if (field === "birthDate") {
      const age = this.calculateAge(value);
      if (age !== null && age < 18) {
        this.setState({
          message: {
            type: "error",
            text: "Kayıt olabilmek için en az 18 yaşında olmanız gerekmektedir.",
          },
        });
      } else {
        this.setState({ message: { type: "", text: "" } });
      }
    }
  };

  togglePasswordVisibility = (field = "showPassword") => {
    this.setState({ [field]: !this.state[field] });
  };

  handleLoginNavigation = () => {
    if (this.state.redirectTimer) {
      clearTimeout(this.state.redirectTimer);
      this.setState({ redirectTimer: null });
    }

    this.setState({ shouldRedirect: "/login" });
  };

  closePaymentPage = () => {
    this.setState({
      showPaymentPage: false,
      paymentPageHTML: null,
      shouldRedirect: "/register",
    });
  };

  componentDidUpdate(prevProps, prevState) {
    if (
      prevState.message.text !== this.state.message.text &&
      this.state.message.text
    ) {
      if (this.state.message.type === "error") {
        setTimeout(() => {
          if (this.state.message.type === "error") {
            this.setState({ message: { type: "", text: "" } });
          }
        }, 5000);
      }
    }
  }

  renderOptionSelector = () => {
    const { selectedOption } = this.state;

    return (
      <div style={{ marginBottom: "30px" }}>
        <div
          style={{
            display: "flex",
            gap: "15px",
            padding: "8px",
            background: "#f8fafc",
            borderRadius: "16px",
            border: "2px solid #e2e8f0",
          }}
        >
          <button
            type="button"
            onClick={() => this.handleOptionChange("register")}
            style={{
              flex: 1,
              padding: "16px 20px",
              border: "none",
              borderRadius: "12px",
              fontSize: "15px",
              fontWeight: "600",
              cursor: "pointer",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              gap: "8px",
              transition: "all 0.3s ease",
              background:
                selectedOption === "register"
                  ? "linear-gradient(135deg, #10b981 0%, #059669 100%)"
                  : "transparent",
              color: selectedOption === "register" ? "white" : "#64748b",
              boxShadow:
                selectedOption === "register"
                  ? "0 4px 15px rgba(16, 185, 129, 0.3)"
                  : "none",
            }}
          >
            <UserPlus size={18} />
            Kayıt Ol
          </button>

          <button
            type="button"
            onClick={() => this.handleOptionChange("giftCode")}
            style={{
              flex: 1,
              padding: "16px 20px",
              border: "none",
              borderRadius: "12px",
              fontSize: "15px",
              fontWeight: "600",
              cursor: "pointer",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              gap: "8px",
              transition: "all 0.3s ease",
              background:
                selectedOption === "giftCode"
                  ? "linear-gradient(135deg, #f59e0b 0%, #d97706 100%)"
                  : "transparent",
              color: selectedOption === "giftCode" ? "white" : "#64748b",
              boxShadow:
                selectedOption === "giftCode"
                  ? "0 4px 15px rgba(245, 158, 11, 0.3)"
                  : "none",
            }}
          >
            <Gift size={18} />
            Hediye Kodu
          </button>
        </div>
      </div>
    );
  };

  renderMockDataButton = () => {
    if (this.state.selectedOption !== "register") return null;

    return (
      <div style={{ marginBottom: "25px", textAlign: "center" }}>
        <button
          type="button"
          onClick={this.fillMockData}
          style={{
            background: "linear-gradient(135deg, #8b5cf6 0%, #7c3aed 100%)",
            color: "white",
            padding: "12px 25px",
            border: "none",
            borderRadius: "10px",
            fontSize: "14px",
            fontWeight: "600",
            cursor: "pointer",
            display: "inline-flex",
            alignItems: "center",
            gap: "8px",
            boxShadow: "0 4px 15px rgba(139, 92, 246, 0.3)",
            transition: "all 0.2s ease",
          }}
          onMouseEnter={(e) => {
            e.target.style.transform = "translateY(-2px)";
            e.target.style.boxShadow = "0 6px 20px rgba(139, 92, 246, 0.4)";
          }}
          onMouseLeave={(e) => {
            e.target.style.transform = "translateY(0px)";
            e.target.style.boxShadow = "0 4px 15px rgba(139, 92, 246, 0.3)";
          }}
        >
          <svg width="16" height="16" fill="currentColor" viewBox="0 0 24 24">
            <path d="M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zM9 17H7v-7h2v7zm4 0h-2V7h2v10zm4 0h-2v-4h2v4z" />
          </svg>
          Test Verilerini Doldur
        </button>
        <div
          style={{
            marginTop: "8px",
            fontSize: "12px",
            color: "#64748b",
            fontStyle: "italic",
          }}
        >
          Geliştirme amaçlı - Hediye kodu ve referans kodu hariç tüm alanları
          doldurur
        </div>
      </div>
    );
  };

  renderGiftCodeQuantity = () => {
    const { giftCodeQuantity } = this.state;

    return (
      <div style={{ marginBottom: "25px" }}>
        <label
          style={{
            display: "block",
            marginBottom: "12px",
            fontSize: "16px",
            fontWeight: "600",
            color: "#374151",
            textAlign: "center",
          }}
        >
          Kaç adet hediye kodu satın almak istiyorsunuz?
        </label>

        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            gap: "15px",
            padding: "20px",
            background: "#fef3c7",
            borderRadius: "16px",
            border: "2px solid #fbbf24",
            marginBottom: "20px",
          }}
        >
          <button
            type="button"
            onClick={() => this.handleQuantityChange(giftCodeQuantity - 1)}
            disabled={giftCodeQuantity <= 1}
            style={{
              width: "45px",
              height: "45px",
              border: "2px solid #d97706",
              borderRadius: "12px",
              background: giftCodeQuantity <= 1 ? "#fbbf24" : "white",
              color: giftCodeQuantity <= 1 ? "white" : "#d97706",
              fontSize: "20px",
              fontWeight: "bold",
              cursor: giftCodeQuantity <= 1 ? "not-allowed" : "pointer",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              transition: "all 0.2s ease",
            }}
          >
            -
          </button>

          <div
            style={{
              padding: "12px 25px",
              background: "white",
              borderRadius: "12px",
              border: "2px solid #d97706",
              fontSize: "18px",
              fontWeight: "700",
              color: "#92400e",
              minWidth: "80px",
              textAlign: "center",
            }}
          >
            {giftCodeQuantity}
          </div>

          <button
            type="button"
            onClick={() => this.handleQuantityChange(giftCodeQuantity + 1)}
            disabled={giftCodeQuantity >= 100}
            style={{
              width: "45px",
              height: "45px",
              border: "2px solid #d97706",
              borderRadius: "12px",
              background: giftCodeQuantity >= 100 ? "#fbbf24" : "white",
              color: giftCodeQuantity >= 100 ? "white" : "#d97706",
              fontSize: "20px",
              fontWeight: "bold",
              cursor: giftCodeQuantity >= 100 ? "not-allowed" : "pointer",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              transition: "all 0.2s ease",
            }}
          >
            +
          </button>
        </div>

        <div style={{ marginBottom: "20px" }}>
          <label
            style={{
              display: "block",
              marginBottom: "8px",
              fontSize: "14px",
              fontWeight: "600",
              color: "#374151",
            }}
          >
            Telefon Numarası (İsteğe Bağlı)
          </label>
          <PhoneInput
            placeholder="Telefon numaranızı girin"
            value={this.state.giftCodePhone}
            onChange={(value) => this.setState({ giftCodePhone: value })}
            defaultCountry="TR"
            international={true}
            countryCallingCodeEditable={false}
            addInternationalOption={false}
            countries={["TR"]}
            labels={trLabels}
            style={{
              border: "2px solid #e2e8f0",
              borderRadius: "12px",
              padding: "8px 15px",
              background: "#ffffff",
              transition: "border-color 0.2s ease",
              width: "100%",
            }}
            className="custom-phone-input"
          />
          <div
            style={{
              marginTop: "8px",
              padding: "8px 12px",
              background: "#fef3c7",
              border: "1px solid #f59e0b",
              borderRadius: "8px",
              fontSize: "12px",
              color: "#92400e",
              display: "flex",
              alignItems: "center",
              gap: "6px",
            }}
          >
            <Shield size={12} />
            <span>
              <strong>SMS sadece Türk numaralarına gönderilir.</strong> Telefon
              numarası isteğe bağlıdır.
            </span>
          </div>
        </div>

        <div
          style={{
            padding: "15px",
            background: "#fef3c7",
            borderRadius: "12px",
            textAlign: "center",
            fontSize: "14px",
            color: "#92400e",
            marginBottom: "20px",
          }}
        >
          <strong>Toplam Tutar: {giftCodeQuantity * 350}₺</strong>
          <br />
          <span style={{ fontSize: "12px", opacity: "0.8" }}>
            Her hediye kodu 350₺'dir
          </span>
        </div>

        <div style={{ marginBottom: "20px" }}>
          <label
            style={{
              display: "flex",
              alignItems: "center",
              gap: "12px",
              cursor: "pointer",
              fontSize: "14px",
              color: "#374151",
              padding: "15px",
              background: "#fef3c7",
              borderRadius: "12px",
              border: "2px solid #f59e0b",
              transition: "all 0.2s ease",
            }}
          >
            <input
              type="checkbox"
              checked={this.state.giftCodeAcceptTerms}
              onChange={(e) =>
                this.setState({ giftCodeAcceptTerms: e.target.checked })
              }
              required
              style={{
                width: "18px",
                height: "18px",
                accentColor: "#f59e0b",
                cursor: "pointer",
              }}
            />
            <span>
              <a
                href="/gizlilik_politikasi/uyelik_satis_sozlesmesi"
                target="_blank"
                rel="noopener noreferrer"
                style={{
                  color: "#d97706",
                  textDecoration: "none",
                  fontWeight: "600",
                }}
              >
                Üyelik & Satış Sözleşmesi
              </a>
              'ni okudum ve kabul ediyorum *
            </span>
          </label>
        </div>
      </div>
    );
  };
  renderMessage = () => {
    const { message } = this.state;
    if (!message.text) return null;

    return (
      <div
        style={{
          background:
            message.type === "success"
              ? "linear-gradient(135deg, #dcfce7 0%, #bbf7d0 100%)"
              : "linear-gradient(135deg, #fef2f2 0%, #fecaca 100%)",
          border: `1px solid ${
            message.type === "success" ? "#10b981" : "#ef4444"
          }`,
          borderRadius: "12px",
          padding: "15px 20px",
          marginBottom: "25px",
          color: message.type === "success" ? "#065f46" : "#991b1b",
          fontSize: "14px",
          fontWeight: "600",
          display: "flex",
          alignItems: "center",
          gap: "8px",
        }}
      >
        {message.type === "success" ? (
          <CheckCircle size={16} />
        ) : (
          <AlertCircle size={16} />
        )}
        {message.text}
      </div>
    );
  };

  renderPaymentPage = () => {
    if (!this.state.showPaymentPage || !this.state.paymentPageHTML) return null;

    return (
      <div
        style={{
          position: "fixed",
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          backgroundColor: "white",
          zIndex: 2000,
          display: "flex",
          flexDirection: "column",
        }}
      >
        <div
          style={{
            padding: "20px",
            borderBottom: "1px solid #e2e8f0",
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            backgroundColor: "#f8fafc",
          }}
        >
          <h2 style={{ margin: 0, color: "#1e293b", fontSize: "20px" }}>
            Ödeme Sayfası
          </h2>
          <button
            onClick={this.closePaymentPage}
            style={{
              background: "none",
              border: "1px solid #e2e8f0",
              borderRadius: "8px",
              padding: "8px 16px",
              cursor: "pointer",
              color: "#64748b",
              fontSize: "14px",
              display: "flex",
              alignItems: "center",
              gap: "8px",
            }}
          >
            <X size={16} />
            Kapat & Giriş Yap
          </button>
        </div>

        <div
          style={{
            flex: 1,
            overflow: "auto",
            padding: "0",
          }}
          dangerouslySetInnerHTML={{
            __html: this.state.paymentPageHTML,
          }}
        />
      </div>
    );
  };

  render() {
    const {
      registerData,
      isLoading,
      showPassword,
      showConfirmPassword,
      shouldRedirect,
      selectedOption,
    } = this.state;

    if (shouldRedirect) {
      return <Navigate to={shouldRedirect} />;
    }

    const careerLevels = [
      { value: "Dört Yıldız", label: "Dört Yıldız" },
      { value: "Beş Yıldız", label: "Beş Yıldız" },
      { value: "Altı Yıldız", label: "Altı Yıldız" },
      { value: "Yedi Yıldız", label: "Yedi Yıldız" },
      { value: "Diğer", label: "Diğer" },
    ];

    // const goldenLionLeaders = [
    //   "Banu Yüksel",
    //   "Deniz Sarı",
    //   "Sevilay Aydın",
    //   "Barış Demirtaş",
    //   "Talha - Aylin Ersoy",
    //   "Kadir - Sevgi Yılmaz",
    //   "Koray - Aslıhan Çelik",
    //   "Alper Tekin",
    //   "Suat Güneş",
    //   "Furkan - Elif Doğan",
    //   "Yasin Tuncel",
    //   "Müjde Aksoy",
    //   "Rıza Uzun",
    // ];

    return (
      <div
        style={{
          minHeight: "100vh",
          background: "linear-gradient(135deg, #f8fafc 0%, #e2e8f0 100%)",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          padding: "20px",
          position: "relative",
          overflow: "hidden",
        }}
      >
        <div
          style={{
            position: "absolute",
            top: "10%",
            left: "10%",
            width: "100px",
            height: "100px",
            background: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
            borderRadius: "50%",
            opacity: "0.1",
            animation: "float 6s ease-in-out infinite",
            zIndex: 0,
          }}
        />
        <div
          style={{
            position: "absolute",
            bottom: "15%",
            right: "15%",
            width: "150px",
            height: "150px",
            background: "linear-gradient(135deg, #3b82f6 0%, #1d4ed8 100%)",
            borderRadius: "50%",
            opacity: "0.1",
            animation: "float 8s ease-in-out infinite reverse",
            zIndex: 0,
          }}
        />

        <div
          className="register-main-container"
          style={{
            background: "linear-gradient(135deg, #ffffff 0%, #f8fafc 100%)",
            borderRadius: "24px",
            padding: "50px",
            boxShadow: "0 25px 80px rgba(0,0,0,0.15)",
            width: "100%",
            maxWidth: "700px",
            position: "relative",
            zIndex: 1,
          }}
        >
          <div
            style={{
              position: "absolute",
              top: "-15px",
              left: "50%",
              transform: "translateX(-50%)",
              background: "#ffffff",
              padding: "8px 20px",
              borderRadius: "20px",
              border: "1px solid #e2e8f0",
              boxShadow: "0 4px 15px rgba(0,0,0,0.1)",
              display: "flex",
              alignItems: "center",
              gap: "6px",
              fontSize: "12px",
              fontWeight: "600",
              color: "#64748b",
            }}
          >
            <Shield size={14} style={{ color: "#10b981" }} />
            Güvenli İşlem
          </div>
          <div style={{ textAlign: "center", marginBottom: "40px" }}>
            <div
              style={{
                background:
                  selectedOption === "register"
                    ? "linear-gradient(135deg, #10b981 0%, #059669 100%)"
                    : "linear-gradient(135deg, #f59e0b 0%, #d97706 100%)",
                width: "80px",
                height: "80px",
                borderRadius: "50%",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                margin: "0 auto 25px",
                color: "white",
                boxShadow:
                  selectedOption === "register"
                    ? "0 8px 25px rgba(16, 185, 129, 0.25)"
                    : "0 8px 25px rgba(245, 158, 11, 0.25)",
                transition: "all 0.3s ease",
              }}
            >
              {selectedOption === "register" ? (
                <UserPlus size={35} />
              ) : (
                <Gift size={35} />
              )}
            </div>

            <h2
              style={{
                fontSize: "28px",
                fontWeight: "700",
                marginBottom: "10px",
                color: "#1e293b",
              }}
            >
              {selectedOption === "register"
                ? "Hesap Oluşturun"
                : "Hediye Kodu Satın Alın"}
            </h2>
            <p
              style={{
                color: "#64748b",
                fontSize: "16px",
                lineHeight: "1.6",
                margin: "0",
              }}
            >
              {selectedOption === "register"
                ? "Bilgilerinizi girerek hemen hesabınızı oluşturun"
                : "Sevdikleriniz için hediye kodu satın alın"}
            </p>
          </div>

          {this.renderOptionSelector()}
          {/* {this.renderMockDataButton()} */}

          {selectedOption === "giftCode" ? (
            <form onSubmit={this.handleRegister}>
              {this.renderGiftCodeQuantity()}

              <button
                type="submit"
                disabled={isLoading || !this.state.giftCodeAcceptTerms}
                style={{
                  background:
                    isLoading || !this.state.giftCodeAcceptTerms
                      ? "#94a3b8"
                      : "linear-gradient(135deg, #f59e0b 0%, #d97706 100%)",
                  color: "white",
                  padding: "18px 40px",
                  border: "none",
                  borderRadius: "12px",
                  fontSize: "16px",
                  fontWeight: "600",
                  cursor:
                    isLoading || !this.state.giftCodeAcceptTerms
                      ? "not-allowed"
                      : "pointer",
                  display: "flex",
                  alignItems: "center",
                  gap: "10px",
                  justifyContent: "center",
                  width: "100%",
                  boxShadow:
                    isLoading || !this.state.giftCodeAcceptTerms
                      ? "none"
                      : "0 8px 25px rgba(245, 158, 11, 0.3)",
                  marginBottom: "25px",
                  transition: "all 0.2s ease",
                  opacity:
                    isLoading || !this.state.giftCodeAcceptTerms ? "0.6" : "1",
                }}
              >
                {isLoading ? (
                  <>
                    <div
                      style={{
                        width: "20px",
                        height: "20px",
                        border: "2px solid #ffffff",
                        borderTop: "2px solid transparent",
                        borderRadius: "50%",
                        animation: "spin 1s linear infinite",
                      }}
                    />
                    İşleminiz hazırlanıyor...
                  </>
                ) : (
                  <>
                    <ShoppingCart size={18} />
                    Hediye Kodu Satın Al ({this.state.giftCodeQuantity * 350}₺)
                  </>
                )}
              </button>
            </form>
          ) : (
            <form onSubmit={this.handleRegister}>
              <div className="register-form-row">
                <div style={{ flex: 1 }}>
                  <label
                    style={{
                      display: "block",
                      marginBottom: "8px",
                      fontSize: "14px",
                      fontWeight: "600",
                      color: "#374151",
                    }}
                  >
                    Ad *
                  </label>
                  <input
                    type="text"
                    value={registerData.firstName}
                    onChange={(e) =>
                      this.handleInputChange("firstName", e.target.value)
                    }
                    required
                    placeholder="Adınız"
                    style={{
                      width: "100%",
                      padding: "15px 18px",
                      border: "2px solid #e2e8f0",
                      borderRadius: "12px",
                      fontSize: "15px",
                      transition: "border-color 0.2s ease",
                      background: "#ffffff",
                    }}
                    onFocus={(e) => (e.target.style.borderColor = "#10b981")}
                    onBlur={(e) => (e.target.style.borderColor = "#e2e8f0")}
                  />
                </div>

                <div style={{ flex: 1 }}>
                  <label
                    style={{
                      display: "block",
                      marginBottom: "8px",
                      fontSize: "14px",
                      fontWeight: "600",
                      color: "#374151",
                    }}
                  >
                    Soyad *
                  </label>
                  <input
                    type="text"
                    value={registerData.lastName}
                    onChange={(e) =>
                      this.handleInputChange("lastName", e.target.value)
                    }
                    required
                    placeholder="Soyadınız"
                    style={{
                      width: "100%",
                      padding: "15px 18px",
                      border: "2px solid #e2e8f0",
                      borderRadius: "12px",
                      fontSize: "15px",
                      transition: "border-color 0.2s ease",
                      background: "#ffffff",
                    }}
                    onFocus={(e) => (e.target.style.borderColor = "#10b981")}
                    onBlur={(e) => (e.target.style.borderColor = "#e2e8f0")}
                  />
                </div>
              </div>

              <div className="register-form-row">
                <div style={{ flex: 1 }}>
                  <label
                    style={{
                      display: "block",
                      marginBottom: "8px",
                      fontSize: "14px",
                      fontWeight: "600",
                      color: "#374151",
                    }}
                  >
                    Ülke *
                  </label>
                  <CountryDropdown
                    value={registerData.country}
                    onChange={(value) =>
                      this.handleInputChange("country", value)
                    }
                    style={{
                      width: "100%",
                      padding: "15px 18px",
                      border: "2px solid #e2e8f0",
                      borderRadius: "12px",
                      fontSize: "15px",
                      transition: "border-color 0.2s ease",
                      background: "#ffffff",
                      appearance: "none",
                      backgroundImage:
                        'url(\'data:image/svg+xml;utf8,<svg fill="%23999" height="20" viewBox="0 0 24 24" width="20" xmlns="http://www.w3.org/2000/svg"><path d="M7 10l5 5 5-5z"/></svg>\')',
                      backgroundRepeat: "no-repeat",
                      backgroundPosition: "right 18px center",
                    }}
                    onFocus={(e) => (e.target.style.borderColor = "#10b981")}
                    onBlur={(e) => (e.target.style.borderColor = "#e2e8f0")}
                    defaultOptionLabel="Ülke Seçin"
                  />
                </div>

                <div style={{ flex: 1 }}>
                  <label
                    style={{
                      display: "block",
                      marginBottom: "8px",
                      fontSize: "14px",
                      fontWeight: "600",
                      color: "#374151",
                    }}
                  >
                    Şehir *
                  </label>
                  <RegionDropdown
                    country={registerData.country}
                    value={registerData.city}
                    onChange={(value) => this.handleInputChange("city", value)}
                    disabled={!registerData.country}
                    style={{
                      width: "100%",
                      padding: "15px 18px",
                      border: "2px solid #e2e8f0",
                      borderRadius: "12px",
                      fontSize: "15px",
                      transition: "border-color 0.2s ease",
                      background: registerData.country ? "#ffffff" : "#f8fafc",
                      appearance: "none",
                      backgroundImage:
                        'url(\'data:image/svg+xml;utf8,<svg fill="%23999" height="20" viewBox="0 0 24 24" width="20" xmlns="http://www.w3.org/2000/svg"><path d="M7 10l5 5 5-5z"/></svg>\')',
                      backgroundRepeat: "no-repeat",
                      backgroundPosition: "right 18px center",
                      cursor: registerData.country ? "pointer" : "not-allowed",
                    }}
                    onFocus={(e) => (e.target.style.borderColor = "#10b981")}
                    onBlur={(e) => (e.target.style.borderColor = "#e2e8f0")}
                    defaultOptionLabel={
                      registerData.country ? "Şehir Seçin" : "Önce ülke seçin"
                    }
                    disableWhenEmpty={true}
                  />
                </div>
              </div>

              <div className="register-form-row">
                <div style={{ flex: 1 }}>
                  <label
                    style={{
                      display: "block",
                      marginBottom: "8px",
                      fontSize: "14px",
                      fontWeight: "600",
                      color: "#374151",
                    }}
                  >
                    Cinsiyet *
                  </label>
                  <select
                    value={registerData.gender}
                    onChange={(e) =>
                      this.handleInputChange("gender", e.target.value)
                    }
                    required
                    style={{
                      width: "100%",
                      padding: "15px 18px",
                      border: "2px solid #e2e8f0",
                      borderRadius: "12px",
                      fontSize: "15px",
                      transition: "border-color 0.2s ease",
                      background: "#ffffff",
                      appearance: "none",
                      backgroundImage:
                        'url(\'data:image/svg+xml;utf8,<svg fill="%23999" height="20" viewBox="0 0 24 24" width="20" xmlns="http://www.w3.org/2000/svg"><path d="M7 10l5 5 5-5z"/></svg>\')',
                      backgroundRepeat: "no-repeat",
                      backgroundPosition: "right 18px center",
                    }}
                    onFocus={(e) => (e.target.style.borderColor = "#10b981")}
                    onBlur={(e) => (e.target.style.borderColor = "#e2e8f0")}
                  >
                    <option value="">Cinsiyet Seçin</option>
                    <option value="male">Erkek</option>
                    <option value="female">Kadın</option>
                  </select>
                </div>

                <div style={{ flex: 1 }}>
                  <label
                    style={{
                      display: "block",
                      marginBottom: "8px",
                      fontSize: "14px",
                      fontWeight: "600",
                      color: "#374151",
                    }}
                  >
                    Doğum Tarihi *
                  </label>
                  <div style={{ position: "relative" }}>
                    <Calendar
                      size={20}
                      style={{
                        position: "absolute",
                        left: "18px",
                        top: "50%",
                        transform: "translateY(-50%)",
                        color: "#9ca3af",
                        zIndex: 1,
                      }}
                    />
                    <input
                      type="date"
                      value={registerData.birthDate}
                      onChange={(e) =>
                        this.handleInputChange("birthDate", e.target.value)
                      }
                      max={this.getMaxBirthDate()}
                      required
                      style={{
                        width: "100%",
                        height: "54px",
                        padding: "0 18px 0 50px",
                        lineHeight: "50px",
                        border: "2px solid #e2e8f0",
                        borderRadius: "12px",
                        fontSize: "15px",
                        transition: "border-color 0.2s ease",
                        background: "#ffffff",
                        boxSizing: "border-box",
                        display: "block",
                        WebkitAppearance: "none",
                        fontFamily: "inherit"
                      }}
                      onFocus={(e) => (e.target.style.borderColor = "#10b981")}
                      onBlur={(e) => (e.target.style.borderColor = "#e2e8f0")}
                    />
                  </div>
                </div>
              </div>

              <div style={{ marginBottom: "20px" }}>
                <label
                  style={{
                    display: "block",
                    marginBottom: "8px",
                    fontSize: "14px",
                    fontWeight: "600",
                    color: "#374151",
                  }}
                >
                  E-posta *
                </label>
                <div style={{ position: "relative" }}>
                  <Mail
                    size={20}
                    style={{
                      position: "absolute",
                      left: "18px",
                      top: "50%",
                      transform: "translateY(-50%)",
                      color: "#9ca3af",
                      zIndex: 1,
                    }}
                  />
                  <input
                    type="email"
                    value={registerData.email}
                    onChange={(e) => {
                      const filtered = e.target.value.replace(
                        /[çğıöşüÇĞİÖŞÜ]/g,
                        ""
                      );
                      this.handleInputChange("email", filtered);
                    }}
                    required
                    placeholder="ornek@email.com"
                    style={{
                      width: "100%",
                      padding: "15px 18px 15px 50px",
                      border: "2px solid #e2e8f0",
                      borderRadius: "12px",
                      fontSize: "15px",
                      transition: "border-color 0.2s ease",
                      background: "#ffffff",
                    }}
                    onFocus={(e) => (e.target.style.borderColor = "#10b981")}
                    onBlur={(e) => (e.target.style.borderColor = "#e2e8f0")}
                  />
                </div>
              </div>

              <div style={{ marginBottom: "20px" }}>
                <label
                  style={{
                    display: "block",
                    marginBottom: "8px",
                    fontSize: "14px",
                    fontWeight: "600",
                    color: "#374151",
                  }}
                >
                  Telefon *
                </label>
                <PhoneInput
                  placeholder="Telefon numaranızı girin"
                  value={registerData.phone}
                  onChange={(value) => this.handleInputChange("phone", value)}
                  defaultCountry="TR"
                  international={true}
                  countryCallingCodeEditable={false}
                  addInternationalOption={false}
                  labels={trLabels}
                  style={{
                    border: "2px solid #e2e8f0",
                    borderRadius: "12px",
                    padding: "8px 15px",
                    background: "#ffffff",
                    transition: "border-color 0.2s ease",
                  }}
                  className="custom-phone-input"
                />
              </div>

              <div className="register-form-row">
                <div style={{ flex: 1 }}>
                  <label
                    style={{
                      display: "block",
                      marginBottom: "8px",
                      fontSize: "14px",
                      fontWeight: "600",
                      color: "#374151",
                    }}
                  >
                    Şifre *
                  </label>
                  <div style={{ position: "relative" }}>
                    <Lock
                      size={20}
                      style={{
                        position: "absolute",
                        left: "18px",
                        top: "50%",
                        transform: "translateY(-50%)",
                        color: "#9ca3af",
                        zIndex: 1,
                      }}
                    />
                    <input
                      type={showPassword ? "text" : "password"}
                      value={registerData.password}
                      onChange={(e) =>
                        this.handleInputChange("password", e.target.value)
                      }
                      required
                      placeholder="En az 6 karakter"
                      style={{
                        width: "100%",
                        padding: "15px 55px 15px 50px",
                        border: "2px solid #e2e8f0",
                        borderRadius: "12px",
                        fontSize: "15px",
                        transition: "border-color 0.2s ease",
                        background: "#ffffff",
                      }}
                      onFocus={(e) => (e.target.style.borderColor = "#10b981")}
                      onBlur={(e) => (e.target.style.borderColor = "#e2e8f0")}
                    />
                    <button
                      type="button"
                      onClick={() =>
                        this.togglePasswordVisibility("showPassword")
                      }
                      style={{
                        position: "absolute",
                        right: "18px",
                        top: "50%",
                        transform: "translateY(-50%)",
                        background: "none",
                        border: "none",
                        cursor: "pointer",
                        color: "#9ca3af",
                        padding: "0",
                      }}
                    >
                      {showPassword ? <EyeOff size={20} /> : <Eye size={20} />}
                    </button>
                  </div>
                </div>

                <div style={{ flex: 1 }}>
                  <label
                    style={{
                      display: "block",
                      marginBottom: "8px",
                      fontSize: "14px",
                      fontWeight: "600",
                      color: "#374151",
                    }}
                  >
                    Şifre Tekrar *
                  </label>
                  <div style={{ position: "relative" }}>
                    <Lock
                      size={20}
                      style={{
                        position: "absolute",
                        left: "18px",
                        top: "50%",
                        transform: "translateY(-50%)",
                        color: "#9ca3af",
                        zIndex: 1,
                      }}
                    />
                    <input
                      type={showConfirmPassword ? "text" : "password"}
                      value={registerData.confirmPassword}
                      onChange={(e) =>
                        this.handleInputChange(
                          "confirmPassword",
                          e.target.value
                        )
                      }
                      required
                      placeholder="Şifrenizi tekrar girin"
                      style={{
                        width: "100%",
                        padding: "15px 55px 15px 50px",
                        border: "2px solid #e2e8f0",
                        borderRadius: "12px",
                        fontSize: "15px",
                        transition: "border-color 0.2s ease",
                        background: "#ffffff",
                      }}
                      onFocus={(e) => (e.target.style.borderColor = "#10b981")}
                      onBlur={(e) => (e.target.style.borderColor = "#e2e8f0")}
                    />
                    <button
                      type="button"
                      onClick={() =>
                        this.togglePasswordVisibility("showConfirmPassword")
                      }
                      style={{
                        position: "absolute",
                        right: "18px",
                        top: "50%",
                        transform: "translateY(-50%)",
                        background: "none",
                        border: "none",
                        cursor: "pointer",
                        color: "#9ca3af",
                        padding: "0",
                      }}
                    >
                      {showConfirmPassword ? (
                        <EyeOff size={20} />
                      ) : (
                        <Eye size={20} />
                      )}
                    </button>
                  </div>
                </div>
              </div>

              <div style={{ marginBottom: "20px" }}>
                <label
                  style={{
                    display: "block",
                    marginBottom: "8px",
                    fontSize: "14px",
                    fontWeight: "600",
                    color: "#374151",
                  }}
                >
                  Kariyer Seviyesi *
                </label>
                <div style={{ position: "relative" }}>
                  <Briefcase
                    size={20}
                    style={{
                      position: "absolute",
                      left: "18px",
                      top: "50%",
                      transform: "translateY(-50%)",
                      color: "#9ca3af",
                      zIndex: 1,
                    }}
                  />
                  <select
                    value={registerData.careerLevel}
                    onChange={(e) =>
                      this.handleInputChange("careerLevel", e.target.value)
                    }
                    required
                    style={{
                      width: "100%",
                      padding: "15px 18px 15px 50px",
                      border: "2px solid #e2e8f0",
                      borderRadius: "12px",
                      fontSize: "15px",
                      transition: "border-color 0.2s ease",
                      background: "#ffffff",
                      appearance: "none",
                      backgroundImage:
                        'url(\'data:image/svg+xml;utf8,<svg fill="%23999" height="20" viewBox="0 0 24 24" width="20" xmlns="http://www.w3.org/2000/svg"><path d="M7 10l5 5 5-5z"/></svg>\')',
                      backgroundRepeat: "no-repeat",
                      backgroundPosition: "right 18px center",
                    }}
                    onFocus={(e) => (e.target.style.borderColor = "#10b981")}
                    onBlur={(e) => (e.target.style.borderColor = "#e2e8f0")}
                  >
                    <option value="">Kariyer Seviyenizi Seçin</option>
                    {careerLevels.map((level) => (
                      <option key={level.value} value={level.value}>
                        {level.label}
                      </option>
                    ))}
                  </select>
                </div>
              </div>

              {/* <div style={{ marginBottom: "20px" }}>
                <label
                  style={{
                    display: "block",
                    marginBottom: "8px",
                    fontSize: "14px",
                    fontWeight: "600",
                    color: "#374151",
                  }}
                >
                  Altın Aslan Lideriniz *
                </label>
                <div style={{ position: "relative" }}>
                  <Crown
                    size={20}
                    style={{
                      position: "absolute",
                      left: "18px",
                      top: "50%",
                      transform: "translateY(-50%)",
                      color: "#9ca3af",
                      zIndex: 1,
                    }}
                  />
                  <select
                    value={registerData.goldenLionLeader}
                    onChange={(e) =>
                      this.handleInputChange("goldenLionLeader", e.target.value)
                    }
                    required
                    style={{
                      width: "100%",
                      padding: "15px 18px 15px 50px",
                      border: "2px solid #e2e8f0",
                      borderRadius: "12px",
                      fontSize: "15px",
                      transition: "border-color 0.2s ease",
                      background: "#ffffff",
                      appearance: "none",
                      backgroundImage:
                        'url(\'data:image/svg+xml;utf8,<svg fill="%23999" height="20" viewBox="0 0 24 24" width="20" xmlns="http://www.w3.org/2000/svg"><path d="M7 10l5 5 5-5z"/></svg>\')',
                      backgroundRepeat: "no-repeat",
                      backgroundPosition: "right 18px center",
                    }}
                    onFocus={(e) => (e.target.style.borderColor = "#10b981")}
                    onBlur={(e) => (e.target.style.borderColor = "#e2e8f0")}
                  >
                    <option value="">Altın Aslan Liderinizi Seçin</option>
                    {goldenLionLeaders.map((leader) => (
                      <option key={leader} value={leader}>
                        {leader}
                      </option>
                    ))}
                  </select>
                </div>
              </div> */}
              {/* 
              <div style={{ marginBottom: "20px" }}>
                <label
                  style={{
                    display: "block",
                    marginBottom: "8px",
                    fontSize: "14px",
                    fontWeight: "600",
                    color: "#374151",
                  }}
                >
                  Referans Kodu
                </label>
                <div style={{ position: "relative" }}>
                  <Users
                    size={20}
                    style={{
                      position: "absolute",
                      left: "18px",
                      top: "50%",
                      transform: "translateY(-50%)",
                      color: "#9ca3af",
                      zIndex: 1,
                    }}
                  />
                  <input
                    type="text"
                    value={registerData.referenceCode}
                    onChange={(e) =>
                      this.handleInputChange("referenceCode", e.target.value)
                    }
                    placeholder="Referans kodunuz (İsteğe bağlı)"
                    style={{
                      width: "100%",
                      padding: "15px 18px 15px 50px",
                      border: "2px solid #e2e8f0",
                      borderRadius: "12px",
                      fontSize: "15px",
                      transition: "border-color 0.2s ease",
                      background: "#ffffff",
                    }}
                    onFocus={(e) => (e.target.style.borderColor = "#10b981")}
                    onBlur={(e) => (e.target.style.borderColor = "#e2e8f0")}
                  />
                </div>
              </div> */}

              <div style={{ marginBottom: "20px" }}>
                <label
                  style={{
                    display: "block",
                    marginBottom: "8px",
                    fontSize: "14px",
                    fontWeight: "600",
                    color: "#374151",
                  }}
                >
                  Hediye Kodu
                </label>
                <div style={{ position: "relative" }}>
                  <Tag
                    size={20}
                    style={{
                      position: "absolute",
                      left: "18px",
                      top: "50%",
                      transform: "translateY(-50%)",
                      color: "#9ca3af",
                      zIndex: 1,
                    }}
                  />
                  <input
                    type="text"
                    value={registerData.giftCode}
                    onChange={(e) =>
                      this.handleInputChange("giftCode", e.target.value)
                    }
                    placeholder="Hediye kodunuz (İsteğe bağlı)"
                    style={{
                      width: "100%",
                      padding: "15px 18px 15px 50px",
                      border: "2px solid #e2e8f0",
                      borderRadius: "12px",
                      fontSize: "15px",
                      transition: "border-color 0.2s ease",
                      background: "#ffffff",
                    }}
                    onFocus={(e) => (e.target.style.borderColor = "#10b981")}
                    onBlur={(e) => (e.target.style.borderColor = "#e2e8f0")}
                  />
                </div>
                {registerData.giftCode &&
                  registerData.giftCode.trim() !== "" && (
                    <div
                      style={{
                        marginTop: "8px",
                        padding: "8px 12px",
                        background: "#dcfce7",
                        border: "1px solid #10b981",
                        borderRadius: "8px",
                        fontSize: "12px",
                        color: "#065f46",
                        display: "flex",
                        alignItems: "center",
                        gap: "6px",
                      }}
                    >
                      <CheckCircle size={14} />
                      Hediye kodu ile kayıt olacaksınız - Ödeme yapmanıza gerek
                      yoktur
                    </div>
                  )}
              </div>

              <div style={{ marginBottom: "15px" }}>
                <label
                  style={{
                    display: "flex",
                    alignItems: "center",
                    gap: "10px",
                    cursor: "pointer",
                    fontSize: "14px",
                    color: "#374151",
                  }}
                >
                  <input
                    type="checkbox"
                    checked={registerData.acceptMarketing}
                    onChange={(e) =>
                      this.handleInputChange(
                        "acceptMarketing",
                        e.target.checked
                      )
                    }
                    style={{
                      width: "18px",
                      height: "18px",
                      accentColor: "#10b981",
                      cursor: "pointer",
                    }}
                  />
                  <span>
                    E-posta yoluyla bildirim ve reklam kampanyası almak
                    istiyorum.
                  </span>
                </label>
              </div>

              <div style={{ marginBottom: "15px" }}>
                <label
                  style={{
                    display: "flex",
                    alignItems: "center",
                    gap: "10px",
                    cursor: "pointer",
                    fontSize: "14px",
                    color: "#374151",
                  }}
                >
                  <input
                    type="checkbox"
                    checked={registerData.acceptTerms}
                    onChange={(e) =>
                      this.handleInputChange("acceptTerms", e.target.checked)
                    }
                    required
                    style={{
                      width: "18px",
                      height: "18px",
                      accentColor: "#10b981",
                      cursor: "pointer",
                    }}
                  />
                  <span>
                    <a
                      href="/gizlilik_politikasi/uyelik_satis_sozlesmesi"
                      style={{
                        color: "#10b981",
                        textDecoration: "none",
                        fontWeight: "600",
                      }}
                    >
                      Üyelik & Satış Sözleşmesi
                    </a>
                    'ni okudum ve kabul ediyorum *
                  </span>
                </label>
              </div>

              <div style={{ marginBottom: "25px" }}>
                <label
                  style={{
                    display: "flex",
                    alignItems: "center",
                    gap: "10px",
                    cursor: "pointer",
                    fontSize: "14px",
                    color: "#374151",
                  }}
                >
                  <input
                    type="checkbox"
                    checked={registerData.acceptPrivacy}
                    onChange={(e) =>
                      this.handleInputChange("acceptPrivacy", e.target.checked)
                    }
                    required
                    style={{
                      width: "18px",
                      height: "18px",
                      accentColor: "#10b981",
                      cursor: "pointer",
                    }}
                  />
                  <span>
                    <a
                      href="/gizlilik_politikasi"
                      style={{
                        color: "#10b981",
                        textDecoration: "none",
                        fontWeight: "600",
                      }}
                    >
                      Kvkk & Gizlilik Politikası
                    </a>
                    'nı okudum ve kabul ediyorum *
                  </span>
                </label>
              </div>
              {this.renderMessage()}

              <button
                type="submit"
                disabled={
                  isLoading ||
                  !registerData.acceptTerms ||
                  !registerData.acceptPrivacy
                }
                style={{
                  background:
                    isLoading ||
                    !registerData.acceptTerms ||
                    !registerData.acceptPrivacy
                      ? "#94a3b8"
                      : "linear-gradient(135deg, #10b981 0%, #059669 100%)",
                  color: "white",
                  padding: "18px 40px",
                  border: "none",
                  borderRadius: "12px",
                  fontSize: "16px",
                  fontWeight: "600",
                  cursor:
                    isLoading ||
                    !registerData.acceptTerms ||
                    !registerData.acceptPrivacy
                      ? "not-allowed"
                      : "pointer",
                  display: "flex",
                  alignItems: "center",
                  gap: "10px",
                  justifyContent: "center",
                  width: "100%",
                  boxShadow:
                    isLoading ||
                    !registerData.acceptTerms ||
                    !registerData.acceptPrivacy
                      ? "none"
                      : "0 8px 25px rgba(16, 185, 129, 0.3)",
                  marginBottom: "25px",
                  transition: "all 0.2s ease",
                }}
              >
                {isLoading ? (
                  <>
                    <div
                      style={{
                        width: "20px",
                        height: "20px",
                        border: "2px solid #ffffff",
                        borderTop: "2px solid transparent",
                        borderRadius: "50%",
                        animation: "spin 1s linear infinite",
                      }}
                    />
                    İşleminiz hazırlanıyor...
                  </>
                ) : (
                  <>
                    <UserPlus size={18} />
                    {registerData.giftCode &&
                    registerData.giftCode.trim() !== ""
                      ? "Hediye Kodu ile Kayıt Ol"
                      : "Hesap Oluştur"}
                  </>
                )}
              </button>
            </form>
          )}

          <div
            style={{
              paddingTop: "20px",
              borderTop: "1px solid #e2e8f0",
              textAlign: "center",
            }}
          >
            <p
              style={{
                color: "#64748b",
                fontSize: "15px",
                margin: "0 0 15px 0",
              }}
            >
              Zaten hesabınız var mı?
            </p>
            <button
              onClick={this.handleLoginNavigation}
              style={{
                background: "none",
                border: "1px solid #e2e8f0",
                color: "#64748b",
                padding: "12px 25px",
                borderRadius: "8px",
                fontSize: "14px",
                fontWeight: "600",
                cursor: "pointer",
                display: "inline-flex",
                alignItems: "center",
                gap: "8px",
                transition: "all 0.2s ease",
              }}
            >
              <QrCode size={16} />
              Giriş Yap
            </button>
          </div>
        </div>

        {this.renderPaymentPage()}

        <style jsx>{`
          @keyframes spin {
            0% {
              transform: rotate(0deg);
            }
            100% {
              transform: rotate(360deg);
            }
          }

          @keyframes float {
            0%,
            100% {
              transform: translateY(0px) rotate(0deg);
            }
            25% {
              transform: translateY(-20px) rotate(5deg);
            }
            50% {
              transform: translateY(-10px) rotate(-5deg);
            }
            75% {
              transform: translateY(-25px) rotate(3deg);
            }
          }

          .PhoneInput {
            border: 2px solid #e2e8f0;
            border-radius: 12px;
            padding: 8px 15px;
            background: #ffffff;
            transition: border-color 0.2s ease;
          }

          .PhoneInput:focus-within {
            border-color: #10b981;
            box-shadow: 0 0 0 3px rgba(16, 185, 129, 0.1);
          }

          .PhoneInputInput {
            border: none !important;
            outline: none !important;
            font-size: 15px;
            padding: 8px 0;
          }

          .PhoneInputCountrySelect {
            border: none;
            background: none;
            padding: 8px;
          }

          .react-country-region-selector {
            border: 2px solid #e2e8f0 !important;
            border-radius: 12px !important;
            padding: 15px 18px !important;
            font-size: 15px !important;
            transition: border-color 0.2s ease !important;
            background: #ffffff !important;
            appearance: none !important;
            background-image: url('data:image/svg+xml;utf8,<svg fill="%23999" height="20" viewBox="0 0 24 24" width="20" xmlns="http://www.w3.org/2000/svg"><path d="M7 10l5 5 5-5z"/></svg>') !important;
            background-repeat: no-repeat !important;
            background-position: right 18px center !important;
          }

          .react-country-region-selector:focus {
            border-color: #10b981 !important;
            outline: none !important;
          }

          ::-webkit-scrollbar {
            width: 8px;
          }

          ::-webkit-scrollbar-track {
            background: #f1f5f9;
            border-radius: 4px;
          }

          ::-webkit-scrollbar-thumb {
            background: #cbd5e1;
            border-radius: 4px;
          }

          ::-webkit-scrollbar-thumb:hover {
            background: #94a3b8;
          }

          @media (max-width: 768px) {
            .main-container {
              padding: 30px 25px !important;
              margin: 10px !important;
              max-width: 95% !important;
            }

            div[style*="position: absolute"][style*="animation"] {
              display: none !important;
            }
          }

          @media (max-width: 480px) {
            .main-container {
              padding: 25px 20px !important;
              max-width: 100% !important;
            }
          }

          button:hover:not(:disabled) {
            transform: translateY(-1px);
          }

          input:focus,
          select:focus {
            outline: none !important;
          }
        `}</style>
      </div>
    );
  }
}
